const AlertPending = ({ onlyIcon = false, extraClass }) => (
  <div className={`flex ${extraClass}`}>
    <span className="font-bold">!</span>
    {!onlyIcon && <p className="ml-2 text-[15px]">Pendent de Resultat</p>}
  </div>
)

export default AlertPending
